import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueCurrencyFilter from 'vue-currency-filter'

import "@/design/index.scss"

Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.use(VueCurrencyFilter, {
   symbol : '€',
   thousandsSeparator: '.',
   fractionCount: 2,
   fractionSeparator: ',',
   symbolPosition: 'rear',
   symbolSpacing: false
   }
 )

Vue.component('apexchart', VueApexCharts)

new Vue({
   router,
   store,
   render: h => h(App)
}).$mount('#app')
